import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'DestinationCrane/MasterTable', method: 'POST', body: filter, token: token })
}
